export const getPartOfFilters = (key, values, additionalKeys) => {
    let partOfFilters = '';
    for (const value of values) {
        if (partOfFilters.length > 0)
            partOfFilters += ' AND ';
        if (additionalKeys !== undefined) {
            partOfFilters += '(';
        }
        partOfFilters += `${key}:"${value}"`;
        if (additionalKeys !== undefined) {
            for (const aKey of additionalKeys) {
                if (partOfFilters.length > 0)
                    partOfFilters += ' OR ';
                partOfFilters += `${aKey}:"${value}"`;
            }
            partOfFilters += ')';
        }
    }
    return partOfFilters;
};
